import { render, staticRenderFns } from "./SidebarView.vue?vue&type=template&id=ac2ccf74&scoped=true&"
import script from "./SidebarView.vue?vue&type=script&lang=js&"
export * from "./SidebarView.vue?vue&type=script&lang=js&"
import style0 from "./SidebarView.vue?vue&type=style&index=0&id=ac2ccf74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2ccf74",
  null
  
)

export default component.exports